export default {
    // 中文配置
    401: '验证失败',
    400: '参数错误',
    500: '服务错误',
};